import { combineReducers } from "redux";
import mainReducer from "./mainReducer";
import productsReducer from "./productsReducer";
import CategoryReducer from "./CategoryReducer";
import websiteReducer from "./websiteReducer";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import cartReducer from "./cartReducer";
import wishlistReducer from "./wishlistReducer";

export default combineReducers({
    main: mainReducer,
    products: productsReducer,
    category: CategoryReducer,
    website: websiteReducer,
    errors: errorReducer,
    auth: authReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
});
